import gql from 'graphql-tag'

export const GET_ME_INFO = gql`
  query {
    me {
      id
      email,
      roleId
    }
  }
`

export default {
  GET_ME_INFO
}
